export function showWithCustomContent(){

	$("."+this.mainClass).html(this.customContent).attr("data-smetio-isVisible", "yes");

};